import { Document } from "../types";
import { prepareDocumentForImport } from "./prepareDocumentForImport";

export const prepareDocumentsForImport = (documents: Document[]): Document[] =>
  documents.map((document) => prepareDocumentForImport(document));
